import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  activeRoleList,
  addSubAdminController,
  adminTypeListController,
  subAdminAccessListController,
  subAdminModuleListController,
} from "../../services/subAdminServices/subAdminServices";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import { Checkbox, FormControlLabel } from "@mui/material";
import { isValidEmail, isValidPhoneNumber } from "../../utility/formValidation";

const AddMember = () => {
  const navigate = useNavigate();
  const [inputFieldValue, setInputFieldValue] = useState({});
  const [errors, setErrors] = useState({});
  // const [moduleName, setModuleName] = useState([]);
  // const [permissionArray, setPermissionArray] = useState([]);
  const [search, setSearch] = useState("");
  // const [selectedProducts, setSelectedProducts] = useState([]);
  const roleDropdownRef = useRef(null);
  const [roleList, setRoleList] = useState([]);

  const fetchRoleList = async () => {
    try {
      const response = await activeRoleList(1, 1000);
      if (response?.data?.code === 200) {
        const roleData = response?.data?.data?.data;
        const activeRoles = roleData.filter((role) => role.status === 1);
        setRoleList(activeRoles);
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
      }
    } catch (e) {
      console.log("Error fetching admin types:", e.message);
    }
  };

  const handleAdminTypeSelect = (selectedRole) => {
    setInputFieldValue({
      ...inputFieldValue,
      roleName: selectedRole.role,
      roleId: selectedRole.id,
    });
  };

  const inputFieldHandler = (e, type = "") => {
    const { name, value } = e.target;
    if (type === "number") {
      let updatedValue = value.replace(/[^0-9]/g, "");
      setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
    } else if (type === "text") {
      let updatedValue = value.replace(/^\s+|\d+/g, "");
      setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
    } else if (type === "email") {
      setInputFieldValue({ ...inputFieldValue, [name]: value.toLowerCase() });
    } else {
      setInputFieldValue({ ...inputFieldValue, [name]: value });
    }
  };

  //   Validate Input Field
  const validation = () => {
    let validationStatus = true;
    const error = {};
    if (!inputFieldValue.name) {
      validationStatus = false;
      error["name"] = "Name is Mandatory *";
    }
    if (!inputFieldValue.email) {
      validationStatus = false;
      error["email"] = "Email is Mandatory *";
    } else if (!isValidEmail(inputFieldValue.email)) {
      validationStatus = false;
      error["email"] = "Enter Valid Email *";
    }
    if (!inputFieldValue.mobileNo) {
      validationStatus = false;
      error["mobileNo"] = "Mobile Number is Mandatory *";
    } else if (!isValidPhoneNumber(inputFieldValue.mobileNo)) {
      validationStatus = false;
      error["mobileNo"] = "Enter Valid Mobile Number *";
    }
    if (!inputFieldValue.password) {
      validationStatus = false;
      error["password"] = "Password is Mandatory *";
    }
    setErrors(error);
    return validationStatus;
  };

  const addSubAdmin = async (e) => {
    e.preventDefault();
    const status = validation();
    if (status) {
      try {
        const response = await addSubAdminController({
          ...inputFieldValue,
          role: inputFieldValue.roleId,
          mobileNo: Number(inputFieldValue.mobileNo),
        });
        if (response?.data?.code === 200) {
          toast.success(response?.data?.message);
          navigate(-1);
        } else {
          toast.error(
            response?.response?.data?.message || response?.data?.message
          );
        }
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  useEffect(() => {
    fetchRoleList();
  }, []);

  return (
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="page-header">
          <h2 className="page-title">
            <span
              className="page-title-icon bg-gradient-primary text-white me-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <i className="mdi mdi-chevron-double-left"></i>
            </span>
            Add Member
          </h2>
          <nav aria-label="breadcrumb"></nav>
        </div>
        <div className="wrap_Add_retailer">
          <div className="col-md-grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <form className="form-sample">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            type="text"
                            maxLength={60}
                            className="form-control"
                            placeholder="Enter Name"
                            name="name"
                            value={inputFieldValue.name}
                            onChange={(e) => inputFieldHandler(e, "text")}
                          />
                          <span style={{ color: "red" }} className="error">
                            {errors.name}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            type="text"
                            maxLength={60}
                            placeholder="Enter Email Address"
                            className="form-control"
                            name="email"
                            value={inputFieldValue?.email?.trim()}
                            onChange={(e) => {
                              inputFieldHandler(e, "email");
                            }}
                          />
                          <span style={{ color: "red" }} className="error">
                            {errors.email}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            type="text"
                            className="form-control"
                            maxLength={10}
                            name="mobileNo"
                            placeholder="Enter Mobile Number"
                            value={inputFieldValue.mobileNo}
                            onChange={(e) => {
                              inputFieldHandler(e, "number");
                            }}
                          />
                          <span style={{ color: "red" }} className="error">
                            {errors.mobileNo}
                          </span>
                        </div>
                      </div>
                      {/* moduleId */}
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            className="form-control"
                            name="password"
                            placeholder="Enter Password"
                            value={inputFieldValue.password}
                            onChange={inputFieldHandler}
                          />
                          <span style={{ color: "red" }} className="error">
                            {errors.password}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Select Role <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9 text-start">
                          <Dropdown
                            className="w-100"
                            autoClose="outside"
                            ref={roleDropdownRef}
                          >
                            <Dropdown.Toggle
                              id="dropdown-autoclose-outside"
                              className="btn text-start"
                            >
                              {inputFieldValue.roleName
                                ? inputFieldValue.roleName
                                : "Select Role"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="cstm_styling_drop_set w-100">
                              <input
                                type="text"
                                placeholder="Search Role"
                                className="form-control m-2"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                              />

                              {roleList
                                ?.filter((adminType) =>
                                  adminType?.role
                                    .toLowerCase()
                                    .includes(search.toLowerCase())
                                )
                                .map((adminType) => (
                                  <Dropdown.Item
                                    key={adminType.id}
                                    onClick={() => {
                                      handleAdminTypeSelect(adminType);
                                      roleDropdownRef.current?.click();
                                    }}
                                    className="text-black"
                                  >
                                    {adminType.role}
                                  </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text">
                    <button
                      type="submit"
                      className="btn btn-gradient-primary mx-3 mt-3"
                      onClick={addSubAdmin}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMember;
